import { Injectable, ErrorHandler } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { INotificationDto } from '../models/notification.model';

@Injectable()
export class NotificationService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getNotificationList(id: number): Observable<INotificationDto[]> {
    return this.get(`notification/${id}`);
  }
}
